import React from 'react';
import { Box } from '@mui/material';

import { FONT } from './constants';

export interface SegmentedTab<K extends string> {
  key: K;
  label: string;
  count?: number;
}

interface SegmentedTabsProps<K extends string> {
  tabs: SegmentedTab<K>[];
  active: K;
  onChange: (key: K) => void;
}

// Segmented control with per-tab count chips, shared by the admin pages.
const SegmentedTabs = <K extends string>({ tabs, active, onChange }: SegmentedTabsProps<K>) => (
  <Box display="inline-flex" gap="2px" bgcolor="#f1f5f9" borderRadius="8px" padding="4px">
    {tabs.map((t) => {
      const isActive = active === t.key;
      return (
        <Box
          key={t.key}
          component="button"
          onClick={() => onChange(t.key)}
          display="flex"
          alignItems="center"
          gap="7px"
          padding="6px 16px"
          borderRadius="6px"
          fontSize={16}
          fontWeight={isActive ? 700 : 500}
          sx={{
            cursor: 'pointer',
            border: isActive ? '1px solid #7801ef' : '1px solid transparent',
            fontFamily: 'inherit',
            color: isActive ? '#7801ef' : '#64748b',
            backgroundColor: isActive ? '#fff' : 'transparent',
          }}
        >
          {t.label}
          {typeof t.count === 'number' && (
            <Box
              component="span"
              fontSize={FONT.sm}
              fontWeight={600}
              padding="1px 7px"
              borderRadius="999px"
              bgcolor={isActive ? 'rgba(120,1,239,0.12)' : 'rgba(100,116,139,0.14)'}
              color={isActive ? '#7801ef' : '#64748b'}
            >
              {t.count}
            </Box>
          )}
        </Box>
      );
    })}
  </Box>
);

export default SegmentedTabs;
